import React, { useEffect, useState } from 'react';
import { StatCard } from './charts/StatCard';
import { BarChart } from './charts/BarChart';
import { AdminDataService } from '../services/AdminDataService';
import { DashboardOverview } from '../types';
import './OverviewDashboard.css';

export const OverviewDashboard: React.FC = () => {
  const [data, setData] = useState<DashboardOverview | null>(null);
  const [gamePlayCounts, setGamePlayCounts] = useState<{ label: string; value: number; color?: string }[]>([]);

  useEffect(() => {
    const dataService = AdminDataService.getInstance();
    const overview = dataService.getOverviewData();
    setData(overview);

    const analytics = dataService.getGameAnalytics();
    setGamePlayCounts(analytics.playCountPerGame.slice(0, 10));
  }, []);

  if (!data) return null;

  return (
    <div className="admin-overview">
      <h2 className="admin-overview__title">Dashboard Overview</h2>

      <div className="admin-overview__stats-grid">
        <StatCard
          icon="👥"
          label="Total Users"
          value={data.totalUsers}
          variant="blue"
          trend="up"
          trendValue="+12%"
        />
        <StatCard
          icon="🎮"
          label="Games Played"
          value={data.totalGamesPlayed}
          variant="green"
          trend="up"
          trendValue={`${data.gamesToday} today`}
        />
        <StatCard
          icon="⚡"
          label="Active Sessions"
          value={data.activeSessions}
          variant="orange"
        />
        <StatCard
          icon="📅"
          label="Games Today"
          value={data.gamesToday}
          variant="purple"
        />
        <StatCard
          icon="🏆"
          label="Most Popular"
          value={data.mostPopularGame}
          variant="red"
          trend="neutral"
          trendValue={`${data.mostPopularGamePlays} plays`}
        />
      </div>

      <div className="admin-overview__quick-stats">
        <div className="admin-overview__quick-stat">
          <span className="admin-overview__quick-stat-label">This Week</span>
          <span className="admin-overview__quick-stat-value">{data.gamesThisWeek} games</span>
        </div>
        <div className="admin-overview__quick-stat">
          <span className="admin-overview__quick-stat-label">This Month</span>
          <span className="admin-overview__quick-stat-value">{data.gamesThisMonth} games</span>
        </div>
        <div className="admin-overview__quick-stat">
          <span className="admin-overview__quick-stat-label">Avg/Day</span>
          <span className="admin-overview__quick-stat-value">
            {data.gamesThisMonth > 0 ? Math.round(data.gamesThisMonth / 30) : 0}
          </span>
        </div>
      </div>

      {gamePlayCounts.length > 0 && (
        <BarChart
          data={gamePlayCounts}
          title="Top Games by Play Count"
        />
      )}
    </div>
  );
};
